<template>
    <div
        class="background-image"
        :style="{
            backgroundImage:
                'url(' + require('../assets/hojas-azules.png') + ')',
        }"></div>
    <div class="main-content">
        <div class="center-container">
            <form @submit.prevent="handleSubmit" class="form">
                <h2 class="login-title"># de consultorio</h2>
                <div class="input-container">
                    <input
                        type="text"
                        v-model="inputValues[0]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="focusNext(0)"
                        @keydown.delete="focusPrevious(0)" />
                    <input
                        type="text"
                        v-model="inputValues[1]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="focusNext(1)"
                        @keydown.delete="focusPrevious(1)" />
                    <input
                        type="text"
                        v-model="inputValues[2]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="focusNext(2)"
                        @keydown.delete="focusPrevious(2)" />
                    <input
                        type="text"
                        v-model="inputValues[3]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="focusNext(3)"
                        @keydown.delete="focusPrevious(3)" />
                    <input
                        type="text"
                        v-model="inputValues[4]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="focusNext(4)"
                        @keydown.delete="focusPrevious(4)" />
                    <input
                        type="text"
                        v-model="inputValues[5]"
                        maxlength="1"
                        required
                        pattern="\d"
                        class="digit-input"
                        @input="handleSubmit"
                        @keydown.delete="focusPrevious(5)" />
                </div>
                <button type="submit" class="submit-button">Entrar</button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            inputValues: ['', '', '', '', '', ''],
        };
    },
    methods: {
        async handleSubmit() {
            const codigo = this.inputValues.join('');

            try {
                const sessionId = localStorage.getItem('kc_session_state');
                const practitionerId = localStorage.getItem('id-user');
                const response = await axios.put('/api/session/update', {
                    session_id: sessionId,
                    number: codigo,
                    practitioner: practitionerId,
                });

                if (response.status === 200) {
                    localStorage.setItem('number', codigo);
                    localStorage.setItem('token', response.data.token);
                    this.$router.push({ name: 'Pacientes' });
                } else {
                    alert('Código incorrecto');
                }
            } catch (error) {
                console.error('Error al iniciar sesión:', error);
                alert('Código incorrecto');
            } finally {
                this.inputValues = ['', '', '', '', '', ''];
                const firstInput =
                    document.getElementsByClassName('digit-input')[0];
                if (firstInput) {
                    firstInput.focus();
                }
            }
        },
        focusNext(index) {
            if (this.inputValues[index].length === 1 && index < 5) {
                const nextInput =
                    document.getElementsByClassName('digit-input')[index + 1];
                if (nextInput) {
                    nextInput.focus();
                }
            }
        },
        focusPrevious(index) {
            if (this.inputValues[index].length === 0 && index > 0) {
                const previousInput =
                    document.getElementsByClassName('digit-input')[index - 1];
                if (previousInput) {
                    previousInput.focus();
                }
            }
        },
    },
};
</script>

<style scoped>
.background-image {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 75vw;
    height: 85vh;
    background-image: url('../assets/hojas-azules.png');
    background-size: 100% 100%, contain;
    background-position: right bottom, right bottom;
    background-repeat: no-repeat, no-repeat;
    transform: scaleX(-1);
}

.background-image::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
    pointer-events: none;
}

.main-content {
    position: relative; /* asegura que quede encima */
    z-index: 1;
    padding: 2rem;
}

.login-title {
    font-family: 'Drina';
    font-size: 72pt; /* .5 */
}

.form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

h2 {
    color: var(--verde-azulado-vibrante);
}

button {
    padding: 10px 20px;
    background-color: var(--verde-azulado-vibrante);
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-size: 24px;
    font-family: 'Trebuchet MS';
    width: 128px;
    height: 56px;
}

.center-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 75vh; /* Esto asegura que el contenedor ocupe toda la altura de la pantalla */
}

.input-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.digit-input {
    width: 48px;
    height: 59px;
    margin: 5px;
    text-align: center;
    border: 1px solid var(--gris-urbano);
    border-radius: 5px;
    background-color: white;
    font-size: 30pt;
    font-family: 'Trebuchet MS';
    font-weight: bold;
}

.digit-input:focus {
    outline: none;
    border-color: #007bff;
}
</style>
